import { ConfigService } from '../../infra/config'
import { BaseRepository } from '../../infra/base.repository'
import type { CityEntity } from './city.entity'

export class CitiesRepository extends BaseRepository<CityEntity[]> {
    constructor(
        private config: ConfigService = new ConfigService(),
        token?: string,
        cache?: any,
    ) {
        super(config.eventApiUrl + '/cities', token, cache)
    }
}
